import { Grid } from "@mui/material";
import dayjs from "dayjs";
import CustomDatePicker from "../../../../CustomDatePicker";
import Input from "../../../../Input";

export const PaymentCashFields = ({ formik }: { formik: any }) => {
  return (
    <Grid
      container
      sx={{
        width: "100%",
      }}
    >
      <Grid size={6}>
        <CustomDatePicker
          required
          minDate={dayjs(new Date())}
          label="Date"
          name="paymentDate"
          value={formik.values?.paymentDate}
          onChange={(val) => formik.setFieldValue("paymentDate", val)}
          handleBlur={formik.handleBlur}
          error={formik.touched?.paymentDate && formik.errors?.paymentDate}
        />
      </Grid>
      <Grid
        sx={{
          mt: 2,
        }}
        size={12}
      >
        <Input
          label="Note"
          textFieldProps={{
            placeholder: "Enter Note",
            rows: 3,
            multiline: true,
            name: "note",
            onChange: formik.handleChange,
            value: formik.values.note,
          }}
        />
      </Grid>
    </Grid>
  );
};
